import {
  Datagrid,
  List,
  WrapperField,
  NumberField,
  DeleteWithConfirmButton,
  useGetList,
  ListContextProvider,
  TextField,
  useList,
  useListContext,
  FunctionField,
  usePermissions,
  useGetIdentity,
} from "react-admin";
import moment from "moment";
import { RaDatagrid_headerCell } from "../common/inlineStyle";
import { Grid, Stack } from "@mui/material";
import { JSONTree } from "react-json-tree";
import CustomUndoButton from "./CustomUndoButton";
import { useEffect, useState } from "react";
import { RootState } from "../../Store/store";
import { useSelector } from "react-redux";
import { useQuickLook } from "../common/QuickLook/quickLookContext";
import { Button, Toolbar } from "@mui/material";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { checkModuleAccess, isSuperAdmin } from "../../Functions/permissions";
import ssn_masked_placeholder from "../../assets/images/ssn_masked_placeholder.jpg";

const DeletedDocThumbnail = ({ record }: { record: any }) => {
  const quickLook = useQuickLook();
  const { permissions } = usePermissions();
  const { data: getUserData } = useGetIdentity();

  const permissionToViewSSN = isSuperAdmin(
    checkModuleAccess(permissions, "View Docs", "View Proof of SSN"),
    getUserData?.userrole
  );

  const isSSNDoc = record?.DocumentTypeID == 4 || record?.DocumentType === "SSN" || String(record?.source_name).toLowerCase() === "ssn";
  const isMasked = isSSNDoc && !permissionToViewSSN;

  const id = String(record?.application_document_id ?? record?.id ?? "");
  const fileUrl = record?.BlobPathfile;
  const fileName = record?.file_name ?? record?.FileName;
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    return () => {
      if (id) quickLook.clearFocusedEntry(id);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (!fileUrl) return <span>NA</span>;

  const displayUrl = isMasked ? ssn_masked_placeholder : fileUrl;

  const thumbnail = (
    <img
      src={displayUrl}
      alt={fileName || "File preview"}
      style={{ maxWidth: 90, maxHeight: 90, objectFit: "contain" }}
    />
  );

  // Without a QuickLookProvider above us (this list mounts in several places
  // that don't have one), space-to-preview does nothing — render the plain
  // thumbnail instead of promising a preview.
  if (!quickLook.isAvailable) return thumbnail;

  return (
    <div
      tabIndex={0}
      onFocus={() => {
        if (!id) return;
        quickLook.focusEntry(id, { fileUrl: displayUrl, fileName, isMasked });
        setFocused(true);
      }}
      onBlur={() => setFocused(false)}
      style={{
        cursor: "pointer",
        display: "inline-block",
        border: focused ? "2px solid #1976d2" : "2px solid transparent",
        borderRadius: 4,
        lineHeight: 0,
        outline: "none",
      }}
      title="Click, then press space to preview"
    >
      {thumbnail}
    </div>
  );
};

const EmptyList = () => {
  return (
    <>
      <small className="text-muted">
        <i>No Document has been deleted</i>
      </small>
    </>
  );
};

const PostPagination = () => {
  const { page, hasPreviousPage, hasNextPage, setPage } = useListContext();
  if (!hasPreviousPage && !hasNextPage) return null;
  return (
    <>
 
    <>
      {hasPreviousPage && (
        <Button
          key="previous"
          onClick={() => setPage(page - 1)}
          startIcon={<ChevronLeft />}
        >
          {" "}
          Previous
        </Button>
      )}
      {hasNextPage && (
        <Button
          key="next"
          onClick={() => setPage(page + 1)}
          startIcon={<ChevronRight />}
        >
          {" "}
          Next
        </Button>
      )}
    </>
    </>
  );
};
export const GetdeleteddocumentlistList = ({ trn_id, onSourceFull, onRestoreSuccess }: {
  trn_id?: any;
  onSourceFull?: () => void;
  onRestoreSuccess?: () => void;
}) => {
  // const [filter, setFilter] = useState('');
  // const [page, setPage] = useState(1);
  // const perPage = 10;
  // const sort = { field: 'id', order: 'ASC' };
  // const  { data, total, isLoading } = useGetList('deletedDocument1', {
  //     filter: { trn_id },
  //     pagination: { page, perPage },
  //     sort,
  // });

  // const listContext = useList({ data, isLoading });
  // if (isLoading) {
  //     return <div>Loading...</div>;
  // }
  const userRole = useSelector((state: RootState) => state.users.role);
  const trn_id1 = useSelector((state: RootState) => state.users.userTrnId);
  const effectiveTrnId = trn_id ?? trn_id1;
  return (
    // <ListContextProvider value={listContext}>
    <List
      perPage={5}
      pagination={<PostPagination/>}
      empty={<EmptyList />}
      filter={{ trn_id: effectiveTrnId }}
      exporter={false}
      disableSyncWithLocation
    >
      <div
        style={{ marginTop: "-50px", position: "relative", overflowX: "auto" }}
      >
        <Datagrid bulkActionButtons={false} sx={RaDatagrid_headerCell}>
          <NumberField sortable={false} source="id" />
          <FunctionField
            sortable={false}
            label="File Thumbnail"
            render={(record) => <DeletedDocThumbnail record={record} />}
          />
          <FunctionField
            label={"Document Type"}
            render={(record) => {
              if (record.DocumentTypeID == 2) return "DL Front";
              if (record.DocumentTypeID == 13) return "DL Back Barcode";
              if (record.DocumentTypeID == 1) return "Passport";
              if (record.DocumentTypeID == 10) return "PRID";
              if (record.DocumentTypeID == 11) return "Visa";
              if (record.DocumentTypeID == 6) return "Bank";
              if (record.DocumentTypeID == 3) return "Income";
              if (record.DocumentTypeID == 7) return "Other Income";
              if (record.DocumentTypeID == 5) return "Other Docs";
              if (record.DocumentTypeID == 4) return "SSN";
              if (record.DocumentTypeID == 14) return "Pet";

              return "NA";
            }}
          />
          <FunctionField
            label="Source Number"
            render={(record) => {
              if (record.OtherIncomeNumber) {
                return record.OtherIncomeNumber;
              }
              if (record.EmployerNumber) {
                return record.EmployerNumber;
              }
              if (record.BankStatementNumber) {
                return record.BankStatementNumber;
              }
              return "NA";
            }}
          />
          <FunctionField
            label="Date Uploaded"
            render={(record) => {
              if (record.CreatedOn !== undefined && record.CreatedOn !== null) {
                return moment
                  .tz(record.CreatedOn, "America/New_York")
                  .format("YYYY-MM-DD h:mm z");
              }
              return "NA";
            }}
          />

          <FunctionField
            label="Date Deleted"
            render={(record) => {
              if (
                record.ModifiedOn !== undefined &&
                record.ModifiedOn !== null
              ) {
                return moment
                  .tz(record.ModifiedOn, "America/New_York")
                  .format("YYYY-MM-DD h:mm z");
              }
              return "NA";
            }}
          />
          <WrapperField label="Action">
            <FunctionField
              label="File Name"
              render={(record) => {
                return (
                  <Stack direction="row" spacing={1}>
                    <CustomUndoButton
                      record={{ ...record, trn_id: record.trn_id ?? effectiveTrnId }}
                      resource="deletedDocument"
                      title={"Restore document"}
                      onSourceFull={onSourceFull}
                      onRestoreSuccess={onRestoreSuccess}
                    />
                    {userRole === "Docuverus Super Admin" && (
                      <DeleteWithConfirmButton
                        redirect={false}
                        confirmTitle="Permanent Delete"
                        confirmContent="You will not be able to recover this record. Are you sure?"
                      />
                    )}
                  </Stack>
                );
              }}
            />
          </WrapperField>
        </Datagrid>
      </div>
    </List>
    // </ListContextProvider>
  );
};
